"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApptSummaryMachine = exports.machineJSON = void 0;
const xstate_1 = require("xstate");
const States_1 = require("../../lib/constants/States");
const utils_1 = require("../../lib/utils");
// Placeholder machine in case we need to support things like appt cancellation, going back in the flow, etc.
const machineJSON = ({ bookedAppt, provider, selectedAppointment, visibility, featureFlags, apiBaseURL, waitlistStatus // Default to null if not provided
 }) => ({
    id: `Machine__${States_1.apptSummary}`,
    initial: States_1.idle,
    context: {
        bookedAppt,
        location: (0, utils_1.getApptLocation)(provider, selectedAppointment),
        provider,
        selectedAppointment,
        visibility,
        featureFlags,
        apiBaseURL,
        waitlistStatus
    },
    states: {
        [States_1.idle]: {}
    }
});
exports.machineJSON = machineJSON;
const createApptSummaryMachine = (props) => (0, xstate_1.Machine)((0, exports.machineJSON)(props));
exports.createApptSummaryMachine = createApptSummaryMachine;
//# sourceMappingURL=apptSummary.js.map